<sh-form-multi-select-base
    [id]="'sort-select'"
    [formControl]="filtersControl"
    [multiple]="false"
    [options]="sortFormSelectOptions$ | async"
    [isLoading]="loading"
    [prefixMsg]="prefixMessage"
    [class]="multiSelectStyle"
    [allowSingleDeselect]="false"
>
</sh-form-multi-select-base>
